import { inject, Injectable } from '@angular/core';
import { LivrablePrincipal } from '@shared/models/livrable-principal.enum';
import { DateTime } from 'luxon';

import { Cartographie } from '../../cartographie/models/cartographie.model';
import { RéférentielLivrableStore } from '../../dashboard/store/référentiel-livrable.store';
import { Référentiel } from '../../administration/gestion-référentiels/models/référentiel.model';

@Injectable({
  providedIn: 'root',
})
export class EstVerrouilleService {
  #referentielLivrableStore = inject(RéférentielLivrableStore);

  check(
    nomLivrable: LivrablePrincipal,
    cartographie: Cartographie,
    référentiel: Référentiel | null,
    idParcours?: string,
  ): boolean {
    const livrableCarto = cartographie?.livrables.find((x) => x.nom === nomLivrable);
    const now = DateTime.now().toFormat('yyyy-MM-dd');
    const dateEcheance = livrableCarto?.dateEcheance?.toString();
    const estDatePassée = dateEcheance !== undefined ? dateEcheance < now : false;
    const livrableRéférentiel = this.#referentielLivrableStore
      .entities()
      .find(
        (x) => x.referentiel.id === référentiel?.id && x.nomLivrable === nomLivrable && x.idParcours === idParcours,
      );
    const estVerrouillé =
      livrableRéférentiel?.estVerrouille !== undefined ? livrableRéférentiel?.estVerrouille : estDatePassée;

    return estVerrouillé;
  }
}
